<template>

    <div v-if="Object.keys(this.successNotifications).length > 0" class="my-3">
        <div class="alert alert-success d-flex justify-content-center" role="alert">
            <ul v-if="Object.keys(this.successNotifications).length > 1" class="my-0">
                <li v-for="(msg, index) in this.successNotifications" :key="index">{{msg}}</li>
            </ul>
            <!-- when there is just 1 message to display -->
            <span v-else class="" v-html="this.successNotifications[0]"></span>
        </div>
    </div>

    <div v-if="Object.keys(this.warningNotifications).length > 0" class="my-3">
        <div class="alert alert-warning d-flex justify-content-center" role="alert">
            <ul v-if="Object.keys(this.warningNotifications).length > 1" class="my-0">
                <li v-for="(msg, index) in this.warningNotifications" :key="index">{{msg}}</li>
            </ul>
            <!-- when there is just 1 message to display -->
            <span v-else class="" v-html="this.warningNotifications[0]"></span>
        </div>
    </div>
    
    <div v-if="Object.keys(this.errorNotifications).length > 0" class="my-3">
        <div class="alert alert-warning d-flex justify-content-center" role="alert">
            <ul v-if="Object.keys(this.errorNotifications).length > 1" class="my-0">
                <li v-for="(msg, index) in this.errorNotifications" :key="index">{{msg}}</li>
            </ul>
            <!-- when there is just 1 message to display -->
            <span v-else class="" v-html="this.errorNotifications[0]"></span>
        </div>
    </div>

</template>

<script>

export default {
    name: 'Notifications',
    components: {
    },
    props: {
        notifications: {
            type: Object,
            required: false,
            default: null,
        },
    },
    data: () => {
        const testData = true;

        return {
            testData,
        };
    },
    methods: {
    },
    computed: {
        testComputed() {
            return true;
        },
        successNotifications() {
            return this.notifications.success; 
        },
        errorNotifications() {
            return this.notifications.error; 
        },
        warningNotifications() {
            return this.notifications.warning; 
        }
    },
    created() {
        // console.log('Component created');
    },
    mounted() {
        // console.log('Component mounted');
    },
    watch: {
    }
};
</script>